import React from 'react';
import AccordionSummary from '@material-ui/core/AccordionSummary';

const CustomAccordionSummary = (props) => {
    return <AccordionSummary {...props} />;
};

export { CustomAccordionSummary as AccordionSummary };
